__turbopack_context__.v({
  "breadcrumb": "LVUq2W_breadcrumb",
  "breadcrumbItem": "LVUq2W_breadcrumbItem",
});
